module.exports = __webpack_public_path__ + "static/media/ki.472c5f4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ki.svg
// module id = 163
// module chunks = 0